import { useEffect } from 'react';
import { createFileRoute, Link, Outlet, useNavigate } from '@tanstack/react-router';
import { AppShell } from '../components/app-shell.js';
import { useMe } from '../components/dashboard-layout.js';

export const Route = createFileRoute('/super')({
  component: SuperLayout,
});

const PLATFORM_NAV = [{ items: [{ label: 'Agent templates', to: '/super/templates' }] }];

function SuperLayout() {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useMe();

  // Not signed in → go to sign-in (don't dead-end on the "admin only" wall).
  useEffect(() => {
    if (!isLoading && (isError || data === null)) void navigate({ to: '/signin' });
  }, [data, isLoading, isError, navigate]);

  if (isLoading || !data) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!data.user.isSuperAdmin) {
    return (
      <main className="mx-auto max-w-md px-6 py-20 text-center">
        <h1 className="text-xl font-semibold">Platform admin only</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          This area is restricted to CartCloser platform administrators.
        </p>
        <Link to="/app" className="mt-6 inline-block text-sm text-primary hover:underline">
          ← Back to dashboard
        </Link>
      </main>
    );
  }

  return (
    <AppShell
      brandSub="Platform"
      nav={PLATFORM_NAV}
      topLink={{ label: '← Dashboard', to: '/app' }}
      email={data.user.email}
    >
      <Outlet />
    </AppShell>
  );
}
